<div class="bg-m0 relative flex h-full w-full flex-col rounded shadow">
  <div class="mb-6 mt-6 flex h-11 flex-shrink-0 flex-row items-center">
    <button
      type="button"
      class="border-s400 text-s500 hover:bg-s100 ml-10 flex select-none flex-row items-center rounded border p-4 py-2 focus:outline-none"
      (click)="copyEventsJson()"
    >
      <div>Copy JSON</div>
    </button>

    <button
      type="button"
      class="text-s500 hover:bg-s100 ml-5 flex h-9 w-9 flex-shrink-0 items-center justify-center rounded focus:outline-none"
      (click)="toggleAllEvents()"
    >
      <m-folder-open-icon *ngIf="allEventsExpanded"></m-folder-open-icon>
      <m-folder-closed-icon *ngIf="!allEventsExpanded"></m-folder-closed-icon>
    </button>

    <div *ngIf="copied" class="text-s1 ml-5 text-lg">Copied!</div>

    <div class="flex flex-1"></div>
  </div>

  <div class="divide-s300 ml-6 mr-6 flex flex-col divide-y">
    <div class="flex flex-row"></div>
    <div class="flex flex-row"></div>
  </div>

  <div class="flex h-2 w-full flex-grow flex-col overflow-y-auto">
    <ng-scrollbar
      [orientation]="'vertical'"
      [visibility]="'hover'"
      [appearance]="'compact'"
    >
      <m-session-debug-events
        [events]="liveEvents"
        [expandedEvents]="debugExpandedEvents"
        (expandedEventsChange)="debugExpandedEvents = $event"
      ></m-session-debug-events>
    </ng-scrollbar>
  </div>
</div>
<div *ngIf="liveEvents$ | async"></div>
<div *ngIf="allEventsExpanded$ | async"></div>
<div *ngIf="toggleAllEvents$ | async"></div>
